import React from 'react';
import {
  ServiceCard as StyledServiceCard,
  ServiceCardIcon,
  ServiceCardContent,
  ServiceCardTitle,
  ServiceCardPrice,
  LearnMoreLink,
  ServiceCardActionAdd,
  ServiceCardActionRemove,
} from '../styles/modalStyles';
import { AdditionalServiceCardIcon } from '../AdditionalServiceCardIcon';
import { formatPrice } from '../../../../../utils/formatPrice';
import CheckIcon from '../../../../../images/icons/check.svg';

export const ServiceCard = ({
  service,
  isSelected,
  onClick,
  showActions = true,
  showCheckIcon = false,
}) => {
  // Define a URL do "Saiba mais" baseado na key do serviço
  const getLearnMoreUrl = () => {
    if (service?.key === '01') {
      return 'https://venda.instacarro.com/laudo-venda/lp';
    }
    if (service?.key === '02') {
      return 'https://venda.instacarro.com/garantia';
    }
    return null;
  };

  const learnMoreUrl = getLearnMoreUrl();

  const handleLearnMoreClick = e => {
    if (learnMoreUrl) {
      e.stopPropagation();
      window.open(learnMoreUrl, '_blank');
    }
  };

  return (
    <StyledServiceCard selected={isSelected} onClick={onClick}>
      <AdditionalServiceCardIcon icon={service.icon} title={service.title} />
      <ServiceCardContent>
        <ServiceCardTitle>{service.title}</ServiceCardTitle>
        <ServiceCardPrice>
          {service.valueText ? `${service.valueText} ` : ''}R${formatPrice(service.value)}
        </ServiceCardPrice>
        {learnMoreUrl && <LearnMoreLink onClick={handleLearnMoreClick}>Saiba mais</LearnMoreLink>}
      </ServiceCardContent>
      {showActions && (
        <>
          {isSelected ? (
            <ServiceCardActionRemove>-</ServiceCardActionRemove>
          ) : (
            <ServiceCardActionAdd>+</ServiceCardActionAdd>
          )}
        </>
      )}
      {showCheckIcon && isSelected && (
        <img src={CheckIcon} alt="Check" style={{ alignSelf: 'center' }} />
      )}
    </StyledServiceCard>
  );
};
